__turbopack_context__.v({
  "comment-container": "_1dAcaq_comment-container",
  "comment-info": "_1dAcaq_comment-info",
  "comment-name": "_1dAcaq_comment-name",
  "comment-rating": "_1dAcaq_comment-rating",
  "comment-review": "_1dAcaq_comment-review",
});
